import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { html, View } from 'rune-ts';
import klass from './Input.module.scss';
import {
  Input_RadioGroup,
  InputRadioGroupData,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_RadioGroup.ts';
import { classes } from '@services/MarppleShop/shared/util';

interface InputAdditionalRadioGroupData<TName extends ValidateField = ValidateField>
  extends Omit<InputRadioGroupData, 'onChange'> {
  name: TName;
  onChange?: (value: boolean) => void;
  additional: {
    views: View[];
    isShow: (selected_id: string) => boolean;
  };
}

export class Input_AddionalRadioGroup<TName extends ValidateField = ValidateField> extends View<
  InputAdditionalRadioGroupData<TName>
> {
  private readonly originalOnChange = this.data.onChange;
  private readonly originalIsShow = this.data.additional.isShow;

  private views: Array<View> = this.data.additional.views;

  private radioGroup = new Input_RadioGroup({
    required: this.data.required,
    name: this.data.name,
    selected_id: this.data.selected_id,
    items: this.data.items,
    title: this.data.title,
    onChange: (view) => {
      const selected = view.getSelected();

      if (selected) {
        const show = this.originalIsShow(selected.id);

        if (this.originalOnChange) this.originalOnChange(show);

        this.element()
          .querySelector<HTMLElement>(`.${klass.addional_text_editor}`)
          ?.classList.toggle(klass.show, show);
      }
    },
  });

  override template() {
    return html`
      <div class="${klass.addional_radio_group}">
        ${this.radioGroup}
        <div
          class="${classes(klass.addional_text_editor, {
            [klass.show]: this.data.additional.isShow(this.data.selected_id),
          })}"
        >
          ${this.views}
        </div>
      </div>
    `;
  }

  public getViews() {
    return this.views;
  }
}
